import React from "react";

const S = {
  page: {
    fontFamily: "'DM Sans', sans-serif",
    background: "#FDF6EC",
    color: "#1A0A00",
    minHeight: "100vh",
    padding: "80px 6%",
    paddingTop: 100,
  },
  inner: {
    maxWidth: 720,
    margin: "0 auto",
  },
  h1: {
    fontSize: 32,
    fontWeight: 700,
    marginBottom: 8,
    color: "#1A0A00",
  },
  meta: {
    fontSize: 13,
    color: "#888",
    marginBottom: 40,
  },
  h2: {
    fontSize: 18,
    fontWeight: 600,
    marginTop: 36,
    marginBottom: 8,
    color: "#1A0A00",
  },
  p: {
    fontSize: 15,
    lineHeight: 1.75,
    color: "#4a3f32",
    marginBottom: 12,
  },
  a: { color: "#E8470A", textDecoration: "none" },
};

export default function PrivacyPage() {
  return (
    <div style={S.page}>
      <div style={S.inner}>
        <h1 style={S.h1}>Privacy Policy</h1>
        <p style={S.meta}>Last updated: April 2026 · The Works Company</p>

        <h2 style={S.h2}>What We Collect</h2>
        <p style={S.p}>
          When you submit the KiranaOS onboarding form, we collect details such as your name, phone number, store name, location, and store photo so we can verify and set up your store. Store owners using the dashboard may share store settings, product information, and order data. Customers placing orders through a KiranaOS store may share their name, phone number, and delivery address.
        </p>

        <h2 style={S.h2}>How We Use It</h2>
        <p style={S.p}>
          We use your information solely to operate and improve KiranaOS -- to send order alerts via WhatsApp, help you manage your store, and contact you about your account. We do not sell your data or your customers' data to any third party, ever.
        </p>

        <h2 style={S.h2}>WhatsApp Messages</h2>
        <p style={S.p}>
          KiranaOS uses WhatsApp Cloud API to send OTP verification codes and order notifications via WhatsApp. By providing your phone number, you consent to receive these messages. You can opt out at any time by contacting us at <a href="mailto:hello@kiranaos.in" style={S.a}>hello@kiranaos.in</a>.
        </p>

        <h2 style={S.h2}>Third Party Services</h2>
        <p style={S.p}>
          KiranaOS uses trusted third-party services to operate the platform including Google Cloud and Meta (WhatsApp). These services have their own privacy policies and handle data only as needed to provide their services.
        </p>

        <h2 style={S.h2}>Data Storage</h2>
        <p style={S.p}>
          Your data is stored securely using industry-standard cloud infrastructure. We take reasonable measures to protect it from unauthorised access or disclosure.
        </p>

        <h2 style={S.h2}>Your Rights</h2>
        <p style={S.p}>
          You may request access to, correction of, or deletion of your personal data at any time. Email us at <a href="mailto:hello@kiranaos.in" style={S.a}>hello@kiranaos.in</a> and we will respond within 30 days.
        </p>

        <h2 style={S.h2}>Contact</h2>
        <p style={S.p}>
          The Works Company<br />
          Email: <a href="mailto:hello@kiranaos.in" style={S.a}>hello@kiranaos.in</a>
        </p>

        <h2 style={S.h2}>Company Information</h2>
        <p style={S.p}>
          KiranaOS is a product of The Works Company, a proprietorship registered in India.
          <br />GSTIN: 09AGVPN5611M2ZM
          <br />Udyam Registration No.: UDYAM-UP-29-0233769 (MSME)
          <br />Contact: <a href="mailto:hello@kiranaos.in" style={S.a}>hello@kiranaos.in</a> · +91 88603 10303
        </p>
        <p style={S.p}>
          You can independently verify our MSME registration at{" "}
          <a href="https://udyamregistration.gov.in" target="_blank" rel="noopener noreferrer" style={S.a}>udyamregistration.gov.in</a>{" "}
          and our GSTIN at{" "}
          <a href="https://www.gst.gov.in" target="_blank" rel="noopener noreferrer" style={S.a}>gst.gov.in</a>.
        </p>
      </div>
    </div>
  );
}
